import { useEffect, useRef, useState } from 'react';
import ManorShell from './ManorShell';
import Draggable, { inside } from './Draggable';
import { RulesButton, RulesModal, useStageSubmit } from './StageChrome';

const RULES = ['Drag and drop the objects to place them in the rightful position to retain the memory.'];

// pos 0 = pocket clock, 1 = rose, 2 = book (matches the pos attributes in stage5.php).
const ITEMS = [
  { pos: 0, item: 'pocket-clock.png', ghost: 'Reflection-Pock-Clock.png', name: 'Pocket clock' },
  { pos: 1, item: 'Rose.png', ghost: 'Reflection_Rose.png', name: 'Rose' },
  { pos: 2, item: 'Ob-Book.png', ghost: 'Reflection-Book.png', name: 'Book' },
];

// Stage 5 (stage5.php): drag each object onto its reflection. When all three are placed the
// mirror shatters, the message opens after 3s, and closing it submits the stage (5 points)
// which finishes the game.
export default function ManorStage5() {
  const submit = useStageSubmit(5);
  const targets = useRef({});
  const timer = useRef(null);
  const [placed, setPlaced] = useState([]);
  const [showRules, setShowRules] = useState(false);
  const [message, setMessage] = useState(false);
  const [closing, setClosing] = useState(false);

  const allPlaced = placed.length === ITEMS.length;

  useEffect(() => {
    if (!allPlaced) return undefined;
    timer.current = setTimeout(() => setMessage(true), 3000);
    return () => clearTimeout(timer.current);
  }, [allPlaced]);

  const drop = (pos) => (pt) => {
    const el = targets.current[pos];
    if (el && inside(el.getBoundingClientRect(), pt, 18) && !placed.includes(pos)) {
      setPlaced((p) => [...p, pos]);
    }
  };

  // The popup vanishes at once; it returns only if saving fails.
  const closeMessage = async () => {
    if (closing) return;
    setClosing(true);
    if ((await submit(5)) === false) setClosing(false);
  };

  return (
    <ManorShell bg="stage5/stage5_bg.png" bgMob="img/stage5/stage5_bg_mob.jpg" stage={5} className="manor-stage5">
      <div className="manor-toolbar">
        <RulesButton onClick={() => setShowRules(true)} />
      </div>
      <img className="manor-drop manor-title" style={{ top: 0, width: '50%' }} src="/manor/img/stage5/Stage5_Title.png" alt="Stage 5" />

      {allPlaced && <img className="manor-shatter" src="/manor/img/stage5/End-Shattermin.gif" alt="" />}

      <div className="manor-scenebox">
      {!allPlaced &&
        ITEMS.map((it) => (
          <div key={it.pos} ref={(el) => (targets.current[it.pos] = el)} className={`manor-ghost manor-ghost-${it.pos}`}>
            <img src={`/manor/img/stage5/${placed.includes(it.pos) ? it.item : it.ghost}`} alt="" draggable={false} />
          </div>
        ))}

      {ITEMS.map((it) =>
        placed.includes(it.pos) ? null : (
          <Draggable key={it.pos} className={`manor-obj manor-obj-${it.pos}`} onDrop={drop(it.pos)}>
            <img src={`/manor/img/stage5/${it.item}`} alt={it.name} draggable={false} />
          </Draggable>
        )
      )}
      </div>

      {showRules && <RulesModal rules={RULES} onClose={() => setShowRules(false)} />}
      {message && closing && <div className="manor-popup-overlay" />}
      {message && !closing && (
        <div className="manor-popup-overlay manor-stage5-overlay">
          <div className="manor-stage5-popup" style={{ backgroundImage: 'url(/manor/img/stage5/Stage5-popupmessage.png)' }}>
            <button type="button" className="manor-img-btn manor-popup-close" onClick={closeMessage} aria-label="Close">
              <img src="/manor/img/cross.png" alt="" />
            </button>
          </div>
        </div>
      )}
    </ManorShell>
  );
}
